'use strict';

require('../../picker/style/');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/date-picker/style/index.js
// module id = 450
// module chunks = 0